import { render, staticRenderFns } from "./messageContent.vue?vue&type=template&id=3bb7e5ea&scoped=true"
import script from "./messageContent.vue?vue&type=script&lang=js"
export * from "./messageContent.vue?vue&type=script&lang=js"
import style0 from "./messageContent.vue?vue&type=style&index=0&id=3bb7e5ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7e5ea",
  null
  
)

export default component.exports